var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2324_7555)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2429 39.6418V20.5671H19.4053V36.0592L26.2429 39.6418Z",
    fill: "url(#paint0_linear_2324_7555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72998 39.6418V20.5671H12.5676V36.0592",
    fill: "url(#paint1_linear_2324_7555)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5676 36.0593L15.9864 34.2687L19.4052 36.0593V16H12.5676V36.0593Z",
    fill: "#FCF2E0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5676 25.8596H5.72998V30.2213C6.65853 30.3811 7.71836 30.3878 8.44314 30.811C9.58913 31.4799 10.199 33.4828 11.5419 33.8535C12.8849 34.2242 14.4684 32.8286 15.8018 32.8447C17.1789 32.8608 18.7296 34.2833 20.0356 33.9542C21.3594 33.6211 22.024 31.6357 23.2083 30.9829C24.0165 30.5383 25.2377 30.6189 26.2442 30.4174V25.8583H12.569L12.5676 25.8596Z",
    fill: "#FC665E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5419 31.1683C10.199 30.7975 9.58908 28.7947 8.4431 28.1257C7.25883 27.4339 5.18019 27.8531 4.24071 26.9047C3.28891 25.9429 3.77575 23.9078 3.11113 22.7445C2.44652 21.5813 0.425322 20.9284 0.0861763 19.6281C-0.248866 18.3453 1.19934 16.822 1.21575 15.4693C1.23216 14.1596 -0.188696 12.6041 0.18874 11.285C0.566176 9.96589 2.60515 9.36679 3.28618 8.24111C3.99045 7.07783 3.56378 5.03604 4.52925 4.1132C5.5084 3.17828 7.58019 3.65649 8.76447 3.00365C9.94874 2.35081 10.6134 0.365441 11.9371 0.0323065C13.2431 -0.296798 14.7939 1.12574 16.171 1.14186C17.5043 1.15798 19.0879 -0.237694 20.4308 0.133053C21.7737 0.503799 22.3836 2.50663 23.5296 3.17559C24.7139 3.86738 26.7925 3.44828 27.732 4.39664C28.6838 5.35843 28.1969 7.3935 28.8616 8.55678C29.5262 9.72007 31.5474 10.3729 31.8865 11.6732C32.2216 12.956 30.7734 14.4793 30.7569 15.832C30.7405 17.1417 32.1614 18.6972 31.784 20.0163C31.4065 21.3354 29.3675 21.9345 28.6865 23.0602C27.9822 24.2235 28.4089 26.2653 27.4434 27.1881C26.4643 28.1231 24.3925 27.6448 23.2082 28.2977C22.024 28.9505 21.3593 30.9359 20.0356 31.269C18.7296 31.5981 17.1788 30.1756 15.8017 30.1595C14.4684 30.1433 12.8848 31.539 11.5419 31.1683Z",
    fill: "url(#paint2_linear_2324_7555)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.981 28.6818C14.7735 28.6818 13.5659 28.5179 12.3926 28.1928C5.35124 26.2464 1.235 19.037 3.21517 12.1204C4.81791 6.52565 10.0706 2.61804 15.9892 2.61804C17.1967 2.61804 18.4042 2.78192 19.5776 3.107C22.9827 4.04864 25.8135 6.23953 27.5488 9.27939C29.2842 12.3179 29.7123 15.8346 28.7536 19.1794C27.1509 24.7742 21.8982 28.6818 15.9796 28.6818H15.981Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.27 24.7689C30.3969 19.7329 30.3969 11.5679 25.27 6.53188C20.1431 1.49587 11.8308 1.49587 6.70394 6.53188C1.57706 11.5679 1.57706 19.7329 6.70394 24.7689C11.8308 29.8049 20.1431 29.8049 25.27 24.7689Z",
    fill: "url(#paint3_linear_2324_7555)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5295 23.0592C27.6951 18.9674 27.6951 12.3334 23.5295 8.2416C19.3639 4.14984 12.6102 4.14984 8.44457 8.2416C4.27898 12.3334 4.27898 18.9674 8.44457 23.0592C12.6102 27.1509 19.3639 27.1509 23.5295 23.0592Z",
    fill: "url(#paint4_linear_2324_7555)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 17.5607C20.2779 17.7071 20.1439 17.828 19.9934 17.828H11.9811C11.8307 17.828 11.6953 17.7071 11.6816 17.5607L11.1825 12.5355C11.1674 12.3891 11.2618 12.3313 11.3903 12.4065L13.8902 13.8908C14.0187 13.9674 14.1979 13.9325 14.2881 13.8143L15.8239 11.8034C15.9141 11.6852 16.0618 11.6852 16.1521 11.8034L17.6878 13.8143C17.778 13.9325 17.9572 13.9661 18.0857 13.8908L20.5856 12.4065C20.7141 12.3299 20.8071 12.3877 20.7934 12.5355L20.2943 17.5607H20.2929Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9894 18.6421H11.9825C11.83 18.6421 11.7063 18.7636 11.7063 18.9134V19.7261C11.7063 19.876 11.83 19.9975 11.9825 19.9975H19.9894C20.1419 19.9975 20.2656 19.876 20.2656 19.7261V18.9134C20.2656 18.7636 20.1419 18.6421 19.9894 18.6421Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6759 10.3701C16.6759 10.7449 16.3668 11.0485 15.9853 11.0485C15.6037 11.0485 15.2947 10.7449 15.2947 10.3701C15.2947 9.99535 15.6037 9.69177 15.9853 9.69177C16.3668 9.69177 16.6759 9.99535 16.6759 10.3701Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8788 11.8612C11.2602 11.8612 11.5694 11.5575 11.5694 11.1829C11.5694 10.8082 11.2602 10.5045 10.8788 10.5045C10.4974 10.5045 10.1882 10.8082 10.1882 11.1829C10.1882 11.5575 10.4974 11.8612 10.8788 11.8612Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7848 11.1829C21.7848 11.5577 21.4757 11.8612 21.0942 11.8612C20.7126 11.8612 20.4036 11.5577 20.4036 11.1829C20.4036 10.8081 20.7126 10.5045 21.0942 10.5045C21.4757 10.5045 21.7848 10.8081 21.7848 11.1829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2324_7555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.506 31.1854C10.1631 30.8146 9.55319 28.8118 8.40721 28.1428C7.22294 27.451 5.1443 27.8701 4.20482 26.9218C3.25302 25.96 3.73986 23.9249 3.07525 22.7616C2.41063 21.5983 0.389433 20.9455 0.0502876 19.6452C-0.284755 18.3624 1.16345 16.8391 1.17986 15.4864C1.19627 14.1767 -0.224584 12.6212 0.152852 11.3021C0.530288 9.98298 2.56926 9.38387 3.25029 8.2582C3.95456 7.09492 3.52789 5.05313 4.49336 4.13029C5.47251 3.19537 7.5443 3.67358 8.72858 3.02074C9.91285 2.3679 10.5775 0.382531 11.9012 0.0493963C13.2072 -0.279708 14.758 1.14283 16.1351 1.15895C17.4684 1.17507 19.052 -0.220604 20.3949 0.150143C21.7378 0.520889 22.3477 2.52372 23.4937 3.19268C24.678 3.88447 26.7566 3.46537 27.6961 4.41372C28.6479 5.37552 28.1611 7.41059 28.8257 8.57387C29.4903 9.73716 31.5115 10.39 31.8506 11.6903C32.1857 12.9731 30.7375 14.4964 30.7211 15.8491C30.7046 17.1588 32.1255 18.7143 31.7481 20.0334C31.3706 21.3525 29.3317 21.9516 28.6506 23.0773C27.9464 24.2406 28.373 26.2824 27.4076 27.2052C26.4284 28.1401 24.3566 27.6619 23.1723 28.3148C21.9881 28.9676 21.3235 30.953 19.9997 31.2861C18.6937 31.6152 17.1429 30.1927 15.7658 30.1766C14.4325 30.1604 12.8489 31.5561 11.506 31.1854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2324_7555)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4,
    d: "M3.08281 -12.4931L-15.7261 19.5074L2.11553 29.6257L20.9244 -2.37481L3.08281 -12.4931Z",
    fill: "url(#paint5_linear_2324_7555)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2324_7555",
    x1: 22.8241,
    y1: 20.5671,
    x2: 22.8241,
    y2: 39.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC665E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2324_7555",
    x1: 9.14742,
    y1: 20.5671,
    x2: 9.14742,
    y2: 39.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC665E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2324_7555",
    x1: 0.035578,
    y1: 15.6507,
    x2: 31.9358,
    y2: 15.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2324_7555",
    x1: 29.1171,
    y1: 15.6506,
    x2: 2.858,
    y2: 15.6506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2324_7555",
    x1: 8.44302,
    y1: 8.24102,
    x2: 23.2611,
    y2: 23.3251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2324_7555",
    x1: -6.80605,
    y1: 24.5681,
    x2: 11.5028,
    y2: -7.71648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2324_7555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressMedal);
export default __webpack_public_path__ + "static/media/progress_medal.ace02eb8d89ce9ac29b0459e6de0d328.svg";
export { ForwardRef as ReactComponent };